import { apiFetch } from './apiClient';

export interface BlockDefinition {
  id: string;
  roomType: string;
  name: string;
  startTime: string;
  endTime: string;
  price: number;
  sortOrder: number;
  isActive: boolean;
  updatedAt: string;
}

export interface CreateBlockPayload {
  roomType: string;
  name: string;
  startTime: string;
  endTime: string;
  price: number;
  sortOrder?: number;
}

export type UpdateBlockPayload = Partial<CreateBlockPayload>;

/** Lấy tất cả blocks grouped by roomType (admin) */
export async function getAll(): Promise<Record<string, BlockDefinition[]>> {
  const res = await apiFetch<{ blocks: Record<string, BlockDefinition[]> }>('/settings/blocks');
  return res.blocks;
}

/** Lấy blocks theo loại phòng (public) */
export async function getByRoomType(roomType: string): Promise<BlockDefinition[]> {
  const res = await apiFetch<{ blocks: BlockDefinition[] }>(`/settings/blocks/${roomType}`, { skipAuth: true });
  return res.blocks;
}

/** Tạo block mới (admin) */
export async function create(data: CreateBlockPayload): Promise<BlockDefinition> {
  return apiFetch<BlockDefinition>('/settings/blocks', {
    method: 'POST',
    body: data,
  });
}

/** Cập nhật block (admin) */
export async function update(id: string, data: UpdateBlockPayload): Promise<BlockDefinition> {
  return apiFetch<BlockDefinition>(`/settings/blocks/${id}`, {
    method: 'PUT',
    body: data,
  });
}

/** Xóa block — soft delete (admin) */
export async function remove(id: string): Promise<void> {
  await apiFetch(`/settings/blocks/${id}`, { method: 'DELETE' });
}

/** Toggle booking mode cho phòng */
export async function updateBookingMode(roomId: string, bookingMode: 'free' | 'block'): Promise<unknown> {
  return apiFetch(`/rooms/${roomId}/booking-mode`, {
    method: 'PUT',
    body: { bookingMode },
  });
}
